import { Timestamp } from '@angular/fire/firestore';
import { GroupReference } from './group.model';
import { LicenceModel } from './licence.model';

export class User {
  public id?: string;
  public type?: 'agent' | 'trainer';
  public internalId?: string;
  public isCompliant?: boolean;
  public isCompliantUpdatedAt?: Date | Timestamp;

  public email?: string;
  public alternativeEmail?: string;

  public firstName?: string;
  public middleName?: string;
  public lastName?: string;
  public nickname?: string;
  public role?: string;
  public roleOther?: string;
  public mobile?: string;
  public alternativeMobile?: string;

  // Storage path of the profile photo — the only thing persisted. Readers get a
  // short-lived signed URL from the getUserPhotoUrls callable.
  public photoPath?: string;
  // Legacy stored URL. No longer written; cleared by the backfill. Retained only
  // so existing documents still typecheck while the field is drained.
  public photoUrl?: string;

  public dateOfBirth?: string;
  public commencementDate?: string;

  public doesNotHaveLicence?: boolean;
  public isMissingLicence?: boolean;
  public licenceNumbers?: string[];
  public licences?: UserLicenceReference[];
  public hasExpiredLicence?: boolean;
  public primaryState?: string;

  public group?: GroupReference;
  public superGroup?: GroupReference;

  public acceptedTerms?: boolean;
  public acceptedTermsAt?: Date | Timestamp;
  public joined?: Date | Timestamp;

  public isDisabled?: boolean;
  public disabledAt?: Date | Timestamp;
  public enabledAt?: Date | Timestamp;

  // Display mirror of the `document-downloader` custom-claim role. The claim is
  // authoritative for enforcement; this flag exists so the admin UI can show and
  // toggle current state without reading Auth claims.
  public canDownloadDocuments?: boolean;
}

export class UserReference {
  public id?: string;
  public email?: string;
  public firstName?: string;
  public lastName?: string;
  public nickname?: string;
  public role?: string;
  public roleOther?: string;
  public mobile?: string;
  public alternativeMobile?: string;
  public alternativeEmail?: string;
  public doesNotHaveLicence?: boolean;
  public isMissingLicence?: boolean;
  public licenceNumbers?: string[];
  public licences?: UserLicenceReference[];
  public hasExpiredLicence?: boolean;
  public dateOfBirth?: string;
  public commencementDate?: string;
  public joined?: Date | Timestamp;
  public group?: GroupReference;
  public profilePic?: string;
  public isGroupAdmin?: boolean;
  // Storage path (denormalized); photoUrl is populated at runtime with a signed URL.
  public photoPath?: string;
  public photoUrl?: string;
  public isArchived?: boolean;
  public archivedAt?: Timestamp;
  public reason?: string;
}

export class RecentlyExpiredLicence extends User {
  public licence?: LicenceModel;
}

export class UserLicenceReference {
  public licenceNumber?: string;
  public region?: string;
}
